import {
    CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE,
    CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_SUCCESS,
} from 'store/actions/types';

export const createAccessPointAccessMethodOpen = (payload) => {
    return {
        type: CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN,
        payload: payload,
    };
};

export const createAccessPointAccessMethodOpenFailure = (error) => {
    return {
        type: CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_FAILURE,
        error: error,
    };
};

export const createAccessPointAccessMethodOpenSuccess = () => {
    return {
        type: CREATE_ACCESS_POINTS_ACCESS_METHOD_OPEN_SUCCESS,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/access-methods/create/createAccessPointAccessMethodOpen.js